import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { createMarkup, autolink, escapeHtml } from '../utils/html';
import { isCurrentUserMessage } from '../utils/message';

export default class TextMessage extends Component {
    static propTypes = {
        authorId: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        className: PropTypes.string,
        linkColor: PropTypes.string,
        role: PropTypes.string.isRequired,
        type: PropTypes.string,
        currentUser: PropTypes.object.isRequired,
    };

    render() {
        const { authorId, className, linkColor, type, role, currentUser } = this.props;
        const linkOptions = {
            target: '_blank',
            class: 'link',
        };

        const isCurrentUser = isCurrentUserMessage({ role, authorId }, currentUser._id);

        if (!isCurrentUser && linkColor) {
            linkOptions.style = `color: #${linkColor}`;
        }

        let text = [];

        if (this.props.text.trim()) {
            text = this.props.text
                .trim()
                .split('\n')
                .map((item, index) => {
                    if (!item.trim()) {
                        return <br key={index} />;
                    }

                    const innerHtml = createMarkup(autolink(escapeHtml(item), linkOptions));

                    return (
                        <span key={index}>
                            <span dangerouslySetInnerHTML={innerHtml}></span>
                            <br />
                        </span>
                    );
                });
        }

        const separator = type === 'file' ? <div className="message-separator"></div> : null;

        return (
            <div>
                <span className={className}>{text}</span>
                {separator}
            </div>
        );
    }
}
